
import OverviewCellBase from "@/app/dynamic-components/overviews/cells/overview-cell.base";
import { Component } from "vue-property-decorator";

@Component({
  components: {},
})
export default class OverviewCellState extends OverviewCellBase {
  public translatedValue() {
    if(!this.value) return this.$t("general.not_available");
    if (!this.metadata.translated && !this.metadata.translationKey) return this.value || 'Not available';
    if(this.metadata.translationKey && this.metadata.translationKey.endsWith('.')) this.metadata.translationKey = this.metadata.translationKey.substring(0,this.metadata.translationKey.length-1);
    if (this.metadata.translationKey) return this.$t(this.metadata.translationKey + '.' + this.value  || "general.not_available");
    return this.$t(this.value || "general.not_available");
  }

  get chipColor(): string {
    return this.metadata["color"] ? this.metadata["color"] : "primary";
  }
}
